import { Capacitor } from '@capacitor/core';

export const platform = Capacitor.getPlatform();
export const isWebApp = Capacitor.getPlatform() === 'web';
export const isiOSApp = Capacitor.getPlatform() === 'ios';
export const isAndroidApp = Capacitor.getPlatform() === 'android';
export const isMobileApp = Capacitor.isNativePlatform();
